import styles from './ObjectsKeyCell.module.scss';
import { Tooltip } from '../../../../../tooltip/Tooltip';
import { LinkButton } from '../../../../../link/LinkButton';
import { getDataIdGenerator } from '../../../../../shared/utils/dataId';
import { ObjectsHeaderAdditionalConfigItem } from '../../../interfaces/object-header';
import { OnDefineKeysClick } from './interface';

export interface ObjectKeyCellProps {
  isViewMode?: boolean;
  objectKeyValue: string | string[];
  isRequired: boolean;
  keyConfig?: ObjectsHeaderAdditionalConfigItem;
  onDefineKeysClick: OnDefineKeysClick;
}
export function ObjectKeyCell({
  isViewMode,
  objectKeyValue,
  isRequired,
  keyConfig,
  onDefineKeysClick
}: ObjectKeyCellProps) {
  const valueString = Array.isArray(objectKeyValue) ? objectKeyValue.join(', ') : objectKeyValue;

  const dataIdGenerator = getDataIdGenerator('object-key-cell');

  return (
    <span className={styles.keyContainer} data-id={dataIdGenerator('')}>
      <span className='text-secondary mr-2'>{keyConfig?.display_name}</span>

      <span className='overflow-hidden'>
        {(!valueString && !isRequired) || (isRequired && isViewMode) ? 'Not Present' : null}

        {valueString ? (
          <Tooltip dataId='' title={valueString} enableOnTextOverflow>
            <span className='d-block text-ellipsis'>{valueString}</span>
          </Tooltip>
        ) : null}

        {isRequired && !isViewMode ? (
          <LinkButton className='' onClick={() => onDefineKeysClick()} dataId={dataIdGenerator('')}>
            <span className='text-primary'>Define</span> <span className={styles.required}>*</span>
          </LinkButton>
        ) : null}
      </span>
    </span>
  );
}
